var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuppliersActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 6V2h-16v4h16zm0 2h-16v8h16V8zm-17-8h18a1 1 0 011 1v16a1 1 0 01-1 1h-18a1 1 0 01-1-1V1a1 1 0 011-1zm2 9h3v5h-3V9zm0-6h2v2h-2V3zm4 0h2v2h-2V3z",
    fill: "#12C1F9"
  })));
}
export default SvgSuppliersActive;